import React from 'react';
import {Col, Label, Row} from 'reactstrap';
import {AvForm, AvRadio, AvRadioGroup} from 'availity-reactstrap-validation';
import {StepComponentProps} from '../followup-modal';
import FollowupButtons from '../followup-buttons';
import '../followup.scss';

const MotherDeliveredStep: React.FC<StepComponentProps> = ({
                                                             formData,
                                                             updateFormData,
                                                             onNext,
                                                             onPrevious,
                                                             canGoBack,
                                                             canGoNext,
                                                             patientCaseType,
                                                             journey,
                                                           }) => {
  const handleSubmit = (event: any, values: any) => {
    onNext();
  };

  const handleIsDeliveredChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value === 'true';
    updateFormData({isDelivered: value});
  };

  return (
    <div className="followup-step-container">
      <div className="followup-step-content">
        <h6 className="text-primary mb-4">Has the Mother Delivered?</h6>
        <AvForm onValidSubmit={handleSubmit}>
          <AvRadioGroup name="isDelivered" required value={formData.isDelivered?.toString()}>
            <Row>
              <Col md="6">
                <Label className="radio-button-label">
                  <AvRadio
                    name="isDelivered"
                    value="true"
                    onChange={handleIsDeliveredChange}
                    className="radio-button-input"
                  />
                  Yes
                </Label>
              </Col>
              <Col md="6">
                <Label className="radio-button-label">
                  <AvRadio
                    name="isDelivered"
                    value="false"
                    onChange={handleIsDeliveredChange}
                    className="radio-button-input"
                  />
                  No
                </Label>
              </Col>
            </Row>
          </AvRadioGroup>

          <FollowupButtons
            currentStep={5}
            totalSteps={13}
            canGoBack={canGoBack}
            onPrevious={onPrevious}
          />
        </AvForm>
      </div>
    </div>
  );
};

export default MotherDeliveredStep;
